export const FIX_SIZE = 'FIX_SIZE';
export const FULL_SIZE = 'FULL_SIZE';
export const HEIGHT_SMALL = 'HEIGHT_SMALL';
export const HEIGHT_LARGE = 'HEIGHT_LARGE';
export const FIELD_TYPE = {
    email: 'email',
    text: 'text',
    number: 'number',
    radio: 'radio',
    checkbox: 'checkbox',
    textarea: 'textarea',
    password: 'password',
    select: 'select',
    file: 'file',
    multi: 'multi',
    date: 'date',
    time: 'time',
    dateTime: 'datetime-local',
    submit: 'submit',
    button: 'button'
};

export default FIELD_TYPE;
